import Utils from "../utils.class";

const {jQuery: $} = window;

export default class ExpandedLoopCarousel extends elementorModules.frontend.handlers.CarouselBase {

    thumbSlider;

    getSwiperSettings() {
        const swiperOptions = super.getSwiperSettings(),
            elementSettings = this.getElementSettings();

        if(elementSettings.pagination === "image") {
            swiperOptions.pagination.type = "none";
            swiperOptions.on.paginationUpdate = (swiper, paginationEl) => {
                $(paginationEl).find(`.swiper-pagination-bullet`).removeClass("swiper-pagination-bullet-prev");
                $(paginationEl).find(`.swiper-pagination-bullet`).removeClass("swiper-pagination-bullet-next");
                $(paginationEl).find(`.swiper-pagination-bullet[data-index="${swiper.realIndex - 1}"]`).addClass("swiper-pagination-bullet-prev");
                $(paginationEl).find(`.swiper-pagination-bullet[data-index="${swiper.realIndex + 1}"]`).addClass("swiper-pagination-bullet-next");
            }
            swiperOptions.centeredSlides = true;

            swiperOptions.on.slideChange = (swiper) => {
                const thumb = this.$element.next(".thumbnail-slider");
                if(thumb.length > 0) {
                    thumb[0].swiper.slideToLoop(swiper.realIndex, 0, false);
                }
            }

            swiperOptions.pagination.renderBullet = (index, className) => {
                return `<span data-index="${index}" class="swiper-slide ${className}"></span>`;
            };
        }

        return swiperOptions;
    }
    async onInit(...args) {
        Utils.log("Registered: Expanded Loop Slider Widget");
        super.onInit(...args);
        this.ranElementHandlers = false;

        if(this.$element.is(".elementor-pagination-type-image")) {
            const size = getComputedStyle(this.$element[0]).getPropertyValue("--swiper-pagination-size");
            const gap = parseInt(getComputedStyle(this.$element[0]).getPropertyValue("--swiper-pagination-bullet-horizontal-gap"));
            const sizeUnit = size.replace(parseInt(size).toString(), "");

            let html = "";
            this.elements.$slides.each((index, el) => {
                const $el = $(el);
                const image = $el.data("image");
                html += `<div class="swiper-slide" style="width: ${size};"><div style="width: ${size}; height: ${size};"><img class="pagination-image" style="width: ${size}; height: ${size}; max-height: 100%;" src="${image}" alt="Slide ${index + 1} Thumbnail"></div></div>`;
            });

            const $thumbs = $(`<div class='thumbnail-slider swiper' style="width: calc((${size} + ${gap + sizeUnit}) * 5)"><div class="swiper-wrapper">${html}</div></div>`);
            this.$element.after($thumbs);

            const thumbSettings = this.getSwiperSettings();

            thumbSettings.slidesPerView = 5;
            thumbSettings.pagination = false;
            thumbSettings.arrows = false;
            thumbSettings.centeredSlides = true;
            thumbSettings.autoHeight = true;

            thumbSettings.effect = 'creative';
            thumbSettings.creativeEffect = {
                limitProgress: 5,
                progressMultiplier: .75,
                prev: {
                    translate: [((parseInt(size) + gap * (2 * 1.75)) * -1).toString() + sizeUnit, "20%", 0],
                    opacity: .50
                },
                next: {
                    translate: [(parseInt(size) + gap * (2 * 1.75)).toString() + sizeUnit,'20%', 0],
                    opacity: .50
                },
            };

            thumbSettings.on.slideChange = (swiper) => {
                this.elements.$swiperContainer[0].swiper.slideToLoop(swiper.realIndex, thumbSettings.loop ? 0 : thumbSettings.speed, false);
            }

            thumbSettings.on.click = (swiper, event) => {
                swiper.slideToLoop(swiper.clickedIndex, thumbSettings.loop ? 0 : thumbSettings.speed, false);
            }

            this.thumbSlider = new Swiper($thumbs[0], thumbSettings);
        }
    }

    a11ySetSlidesAriaLabels() {
        const slides = Array.from(this.elements.$slides);
        slides.forEach((slide, index) => {
            slide.setAttribute('aria-label', `${parseInt(index + 1)} 'of' ${slides.length}`);
        });
    }
}